import graphqlClient from "../../../apollo";

class FacturaProvider {


    getServerStatus() {
        return graphqlClient.query({
            query: require('./gql/Afip/getServerStatus.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getFacturaPdf(facturaId) {
        return graphqlClient.query({
            query: require('./gql/Afip/getFacturaPdf.graphql'),
            variables: {facturaId},
            fetchPolicy: "network-only"
        })
    }

    getTicketFactura(facturaId) {
        return graphqlClient.query({
            query: require('./gql/Afip/getTicketFactura.graphql'),
            variables: {facturaId},
            fetchPolicy: "network-only"
        })
    }

    getQrAfip(facturaId) {
        return graphqlClient.query({
            query: require('./gql/Afip/getQrAfip.graphql'),
            variables: {facturaId},
            fetchPolicy: "network-only"
        })
    }

    getPuntosVenta() {
        return graphqlClient.query({
            query: require('./gql/Afip/getPuntosVenta.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getTipoComprobantes() {
        return graphqlClient.query({
            query: require('./gql/Afip/getTipoComprobantes.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getTipoConceptos() {
        return graphqlClient.query({
            query: require('./gql/Afip/getTipoConceptos.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getTipoDocumentos() {
        return graphqlClient.query({
            query: require('./gql/Afip/getTipoDocumentos.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getTipoAlicuotas() {
        return graphqlClient.query({
            query: require('./gql/Afip/getTipoAlicuotas.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getTipoMonedas() {
        return graphqlClient.query({
            query: require('./gql/Afip/getTipoMonedas.graphql'),
            fetchPolicy: "network-only"
        })
    }

    createElectronicBilling(facturaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/Afip/createElectronicBilling.graphql'),
            variables: {facturaId}
        })
    }



}

export default new FacturaProvider()


